import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { ensureElementVisible } from "@/lib/route-guards";

const DzzfProducersPage = lazy(() =>
	import("@/features/dzzf/dzzf-producers-page").then((m) => ({ default: m.DzzfProducersPage })),
);

export const Route = createFileRoute("/_auth/kontrakty/producenci-dzzf")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.producenci-dzzf",
			location.pathname,
		);
	},
	component: DzzfProducersPage,
});
